"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageResizeOptions = exports.FileUploadQueryParams = exports.FileDeleteResponse = exports.FileDeleteRequest = exports.FileUploadResponse = exports.FileUploadRequest = exports.AttachmentSchema = exports.AttachmentType = void 0;
const zod_1 = require("zod");
var AttachmentType;
(function (AttachmentType) {
    AttachmentType["IMAGE"] = "IMAGE";
    AttachmentType["DOCUMENT"] = "DOCUMENT";
    AttachmentType["VARIATION_SIGNATURE"] = "VARIATION_SIGNATURE";
    // canvas-v2: the editable SitemapDocument (.json) sibling of the flattened .png.
    // Additive only — the DB `type` column is a plain String (no Prisma enum) and
    // AttachmentSchema.type is z.union([nativeEnum, z.string()]), so no migration.
    AttachmentType["SITEMAP_DOC"] = "SITEMAP_DOC";
})(AttachmentType || (exports.AttachmentType = AttachmentType = {}));
exports.AttachmentSchema = {
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    extension: zod_1.z.string(),
    type: zod_1.z.union([zod_1.z.nativeEnum(AttachmentType), zod_1.z.string()]),
    width: zod_1.z.union([zod_1.z.number(), zod_1.z.null()]),
    height: zod_1.z.union([zod_1.z.number(), zod_1.z.null()]),
};
exports.FileUploadRequest = zod_1.z.object({
    fileName: zod_1.z.string(),
    folder: zod_1.z.string().optional(),
    contentType: zod_1.z.string().optional(),
});
exports.FileUploadResponse = zod_1.z.object({
    data: zod_1.z.array(zod_1.z.object({
        fileName: zod_1.z.string(),
        fileUrl: zod_1.z.string(),
        s3Key: zod_1.z.string(),
        contentType: zod_1.z.string(),
        size: zod_1.z.number(),
    })),
});
exports.FileDeleteRequest = zod_1.z.object({
    fileName: zod_1.z.string(),
    folder: zod_1.z.string().optional(),
});
exports.FileDeleteResponse = zod_1.z.object({
    data: zod_1.z.object({
        message: zod_1.z.string(),
        deleted: zod_1.z.boolean(),
    }),
});
exports.FileUploadQueryParams = zod_1.z.object({
    folder: zod_1.z.string().optional(),
    preserveFileName: zod_1.z.boolean().optional(),
    width: zod_1.z.string().optional(),
    height: zod_1.z.string().optional(),
    quality: zod_1.z.string().min(1).max(100).optional(),
});
exports.ImageResizeOptions = zod_1.z.object({
    width: zod_1.z.number().optional(),
    height: zod_1.z.number().optional(),
    quality: zod_1.z.number().min(1).max(100).optional(),
});
